import { useEffect, useRef } from 'react'

const getValuebyName = (data, name, key = 'name') => {
  if (data?.length) {
    const notFound = data?.find(item => {
      const isMatch = item?.[key]?.toLowerCase() === name?.toLowerCase()
      if (isMatch) {
        return isMatch
      }
    })
    return notFound
  }
}

const getBoardbyName = (data, name, key = 'name') => {
  if (data?.length) {
    const notFound = data?.find(item => {
      const isMatch = item?.[key]?.toLowerCase()?.includes(name?.toLowerCase())
      if (isMatch) {
        return isMatch
      }
    })
    return notFound
  }
}
const mumericToBooleanConverter = value => {
  return value == 1 
}
const normalizeString = str => {
  // Remove special characters and convert to lowercase
  return str.replace(/[^\w\s]/gi, '').toLowerCase()
}

function debounce(fn, delay) {
  let timer
  return function () {
    let context = this,
      args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

const shuffleArray = array => {
  return array.slice().sort(() => Math.random() - 0.5)
}
const createMarkup = htmlString => ({ __html: htmlString })

const clearLocalStorageAndCookies = () => {
  // Clear localStorage
  localStorage.clear()

  // Clear all cookies
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
  }
}

const toCamelCase = str => {
  const words = str?.split(' ')
  const camelCaseWords = words?.map(word => {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
  })
  return camelCaseWords?.join(' ')
}
export const detectDateFormat = dateString => {
  const dateFormatRegex = [
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, // ISO 8601 format
    /\d{2}\/\d{2}\/\d{4}/, // DD/MM/YYYY format
    /\d{4}-\d{2}-\d{2}/, // YYYY-MM-DD format
  ]

  for (const regex of dateFormatRegex) {
    if (regex.test(dateString)) {
      return regex.toString().replace(/\//g, '').replace(/\\/g, '')
    }
  }

  return null
}

export const dateConversion = ({ date, convertTo }) => {
  const detectedFormat = detectDateFormat(date)
  if (convertTo === 'Date-Month-Year') {
    const getdate = new Date(date)
    const day = getdate.getUTCDate().toString().padStart(2, '0')
    const month = (getdate.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = getdate.getUTCFullYear().toString()
    return `${day}-${month}-${year}`
  } else if (convertTo === 'Date/Month/Year') {
    const getdate = new Date(date)
    const day = getdate.getUTCDate().toString().padStart(2, '0')
    const month = (getdate.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = getdate.getUTCFullYear().toString()
    return `${day}/${month}\/${year}`
  } else if (
    detectedFormat ===
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
      .toString()
      .replace(/\//g, '')
      .replace(/\\/g, '')
  ) {
    if (convertTo === 'YYYY-MM-DD') {
      const formattedDate = new Date(date).toISOString().split('T')[0]
      return formattedDate
    }
  } else if (
    detectedFormat ===
    /\d{2}\/\d{2}\/\d{4}/.toString().replace(/\//g, '').replace(/\\/g, '')
  ) {
    if (convertTo == 'YYYY-MM-DD') {
      return date?.split('/')?.reverse()?.join('-')
    }
  } else if (
    detectedFormat ===
    /\d{4}-\d{2}-\d{2}/.toString().replace(/\//g, '').replace(/\\/g, '')
  ) {
    if (convertTo == 'DD/MM/YYYY') {
      return date?.split('-')?.reverse()?.join('/')
    }
  } else {
    let inputDate = new Date(date)

    let year = inputDate.getFullYear()
    let month = inputDate.getMonth() + 1 // Months are zero-indexed, so add 1
    let day = inputDate.getDate()

    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }

    let formattedDate = year + '-' + month + '-' + day

    return formattedDate
  }
}
export {
  getValuebyName,
  debounce,
  usePrevious,
  shuffleArray,
  createMarkup,
  getBoardbyName,
  normalizeString,
  mumericToBooleanConverter,
  clearLocalStorageAndCookies,
  toCamelCase,
}
